const model = {
    submitting: false,
    errors: null,
    seasonDetails: null,
    success: false,
};

export default model;
